module.exports = "deb0b9feec07ebec93ba47a9e1627394.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/flags/china.png
// module id = 87
// module chunks = 0